import { Text } from '../../components/Text';
import { CustomButton } from '../../components/CustomButton';
import { useSelector } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import { Toast } from 'primereact/toast';
import axiosInstance from '../../api/axios.instance';
import './index.css';
import ChangePassword from '../../components/ChangePassword';
import Loader from '../../components/Loader';
import TableActionsContainer from '../../components/CustomTable/TableActionsContainer';
import { formatMobNumber } from '../../utils/commonUtils';
import EditProfile from './EditProfile';
import { Image } from 'primereact/image';
import PaymentQR from './PaymentQR';
import QRCodeStyling from 'qr-code-styling';
import QrIcon from '../../assets/qrcenter.png';
import { WIDGET_CSS_EXTENTIONS, WIDGET_JS_EXTENTIONS } from '../../config/FileConstants';
import { Tooltip } from 'primereact/tooltip';
import ProfilePicUpload from './components/profile-pic-upload';
import { isWhiteLabelEnvironment } from '../../utils/whiteLabelUtils';

function Profile() {
  const [dpData, setDpData] = useState(null);
  const [showChangePassword, setChangeShowPassword] = useState(false);
  const [editProfile, setEditProfile] = useState(false);

  const { user, userSub } = useSelector((state) => state.authenticate);
  const { company, loadingC } = useSelector((state) => state.company);
  const ref = useRef(null);
  const toast = useRef(null);

  const isAdmin = user?.role === 'superadmin';
  const isWhiteLabel = isWhiteLabelEnvironment();
  useEffect(() => {
    if (user?.companyId) {
      axiosInstance
        .get(`company/${user.companyId}/image`)
        .then((resp) => {
          setDpData(resp?.data);
          // setGetLogo(resp.data.url);
          // setPutLogo(resp.data.src);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const qrCode = new QRCodeStyling({
    width: 180,
    height: 180,
    image: QrIcon,
    dotsOptions: {
      color: '#000',
      type: 'rounded',
    },
    imageOptions: {
      crossOrigin: 'anonymous',
    },
    backgroundOptions: {
      color: '#f8f9fe',
    },
    backgroundOptionsHelper: {
      colorType: { single: true, gradient: false },
      gradient: {
        linear: true,
        radial: false,
        color1: '#ffffff',
        color2: '#ffffff',
      },
    },
    qrOptions: { typeNumber: '0', mode: 'Byte', errorCorrectionLevel: 'L' },
    imageOptions: { hideBackgroundDots: true, imageSize: 0.5, margin: 0 },
    dotsOptionsHelper: {
      colorType: { single: true, gradient: false },
      gradient: {
        linear: true,
        radial: false,
        color1: '#6a1a4c',
        color2: '#6a1a4c',
        rotation: '0',
      },
    },
    cornersSquareOptions: { type: 'square', color: '#000000' },
    cornersSquareOptionsHelper: {
      colorType: { single: true, gradient: false },
      gradient: {
        linear: true,
        radial: false,
        color1: '#000000',
        color2: '#000000',
        rotation: '0',
      },
    },
    cornersDotOptions: { type: '', color: '#000000' },
    cornersDotOptionsHelper: {
      colorType: { single: true, gradient: false },
      gradient: {
        linear: true,
        radial: false,
        color1: '#000000',
        color2: '#000000',
        rotation: '0',
      },
    },
  });

  useEffect(() => {
    qrCode.append(ref.current);
  }, []);

  useEffect(() => {
    qrCode.update({
      data: `https://wa.me/${company?.phone}?text=Hi`,
    });
  }, [company?.phone]);

  const onDownloadClick = () => {
    qrCode.update({
      data: `https://wa.me/${company?.phone}?text=Hi`,
    });
    qrCode.download({
      extension: 'png',
    });
  };
  const handleCopy = async () => {
    try {
      const text = `<link rel="stylesheet" href="${WIDGET_CSS_EXTENTIONS}" />\n<script src="${WIDGET_JS_EXTENTIONS}" data-app-no="${
        company?.phone
      }" data-business-name="${company?.companyName}" ${
        dpData?.url ? `data-business-img="${dpData?.url}"` : ''
      }></script>`;
      await navigator.clipboard.writeText(text);
      toast.current.show({
        severity: 'success',
        detail: 'The Skalebot widget has been copied.',
      });
    } catch (err) {
      console.error('Failed to read clipboard contents: ', err);
    }
  };

  return (
    <div>
      <Loader visible={loadingC} />
      {editProfile && (
        <EditProfile
          showDialog={editProfile}
          hideDialog={() => setEditProfile(false)}
          toast={toast}
          profilePicData={dpData}
        />
      )}

      <Toast ref={toast} />
      {showChangePassword && (
        <ChangePassword
          showChangePassword={showChangePassword}
          hideChangePassword={() => setChangeShowPassword(false)}
          toast={toast}
        />
      )}
      <div className={`w-full p-3 `}>
        {/* <TableActionsContainer>
            <Text type={"heading"} style={{ padding: "0.9rem 0.5rem" }}>
              User Profile
            </Text>
          </TableActionsContainer> */}

        <div className="my-3">
          <TableActionsContainer>
            <div className="flex align-items-center">
              <ProfilePicUpload />
              <div className="flex-1 flex justify-content-between align-items-start p-3">
                <div className="w-full pt-2">
                  <div className="flex">
                    <Text type={'sub-heading'}>Business Name:&nbsp;</Text>
                    <Text type={'heading'}>&nbsp;{company?.companyName}</Text>
                  </div>

                  <div className="mt-3 flex">
                    <Text type={'sub-heading'}> Subscription Type:&nbsp;</Text>

                    <Text type={'heading'}>
                      &nbsp;
                      <span className="capitalize">
                        {userSub.isUserSub ? userSub.userSubType : 'none'}
                      </span>
                      <span className="capitalize">
                        {userSub.isUserSub && ` (${userSub.plan})`}
                      </span>
                    </Text>
                  </div>
                </div>
                {/* <button
                  className="logo"
                  title={isAdmin ? "Click to modify logo" : undefined}
                  onClick={handleLogoEdit}
                > */}
                <div>
                  <Image
                    src={`${dpData?.url}?v=${new Date().getTime()}`}
                    onError={(e) => (e.target.src = './svgIcons/UserIcon.svg')}
                    alt="Company logo"
                    className="logoImg"
                    width="100px"
                  />
                </div>

                {/* {isAdmin && <img className="editIcon" src={edit} alt="" />}
                </button> */}
              </div>
            </div>
          </TableActionsContainer>
          <div className="w-full flex lg:flex-row flex-column gap-3 flex-wrap justify-content-between py-3 pb-4">
            <div className=" w-12 lg:w-7">
              <Text type={'heading'}>Profile Details</Text>
              <div className="my-3">
                <TableActionsContainer>
                  <div className={`w-full`}>
                    <div>
                      <div className="my-3">
                        <div className="mb-3">
                          <Text type={'sub-heading'}>Business mobile number</Text>
                          <div className="mt-2">
                            <Text type={'heading'}>{formatMobNumber(company?.phone)}</Text>
                          </div>
                        </div>
                        <div className="mb-3">
                          <Text type={'sub-heading'}>Personal mobile number</Text>
                          <div className="mt-2">
                            <Text type={'heading'}>{formatMobNumber(company?.personalPhone)}</Text>
                          </div>
                        </div>
                        <div className="mb-3">
                          <Text type={'sub-heading'}>GST No</Text>
                          <div className="mt-2">
                            <Text type={'heading'}>{company?.gstNumber}</Text>
                          </div>
                        </div>
                        <div className="mb-3">
                          <Text type={'sub-heading'}>PAN No</Text>
                          <div className="mt-2">
                            <Text type={'heading'}>{company?.panNumber}</Text>
                          </div>
                        </div>
                        <div className="mb-3">
                          <Text type={'sub-heading'}>Billing Address</Text>
                          <div className="mt-2">
                            <Text type={'heading'}>{company?.billingAddress}</Text>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex flex-row gap-2 justify-content-end">
                      {isAdmin && (
                        <CustomButton
                          varient="outline"
                          type={'button'}
                          onClick={() => setEditProfile(true)}
                          label={'Edit Profile'}
                        />
                      )}
                    </div>
                  </div>
                </TableActionsContainer>
              </div>
              <div>
                <div className="mb-3">
                  <Text type={'heading'}>Security</Text>
                </div>
                <TableActionsContainer>
                  <div className="my-3 flex justify-content-between">
                    <div>
                      <Text>Password</Text>
                      <div className="mt-2">
                        <Text type={'heading'}>***********</Text>
                      </div>
                    </div>
                    <div>
                      <CustomButton
                        varient="outline"
                        label={'Change Password'}
                        onClick={() => setChangeShowPassword(true)}
                      />
                    </div>
                  </div>
                </TableActionsContainer>
              </div>
              {/* <div>
                  <div className="mb-3">
                    <Text type={"heading"}>Token Generation</Text>
                  </div>
                  <TableActionsContainer>
                    <div className="my-3 flex justify-content-between">
                      <div className="mt-2">
                        <Text>Generate Code</Text>
                      </div>
                      <div>
                        <CustomButton
                          varient="outline"
                          label={<div>&#128203;</div>}
                          onClick={() => {GenerateToken()}}
                        />
                      </div>
                    </div>
                  </TableActionsContainer>
                </div> */}
              {!isWhiteLabel && (
                <div className="mt-3">
                  <div className="mb-3 flex flex-row align-items-center gap-2">
                    <Text type={'heading'}>SkaleBot Widget</Text>
                    <Tooltip target=".custom-target-icon" />

                    <i
                      className="custom-target-icon pi pi-info-circle "
                      data-pr-tooltip={`Embed the code snippet into the <head> section of your website.`}
                      data-pr-position="right"
                      data-pr-at="right+5 top"
                      data-pr-my="left center-2"
                      style={{ fontSize: '14px', cursor: 'pointer' }}
                    ></i>
                  </div>
                  <TableActionsContainer>
                    <div className="my-3 flex justify-content-between">
                      <div className="relative">
                        <Text>Code</Text>
                        <div className="mt-2 flex flex-column language-jsx p-2">
                          <code>{`<link rel="stylesheet" href="${WIDGET_CSS_EXTENTIONS}" />`}</code>
                          <code>{`<script src="${WIDGET_JS_EXTENTIONS}"`}</code>
                          <code>
                            {`data-app-no="${company?.phone}" data-business-name="${company?.companyName}`}
                          </code>
                          <code>
                            {`${dpData?.url ? `data-business-img="${dpData?.url}"` : ''}></script>`}
                          </code>
                        </div>
                        <div className="absolute code-btn">
                          <CustomButton icon="pi pi-copy" varient="outline" onClick={handleCopy} />
                        </div>
                      </div>
                    </div>
                  </TableActionsContainer>
                </div>
              )}
             {!isWhiteLabel && <div className="mt-3">
                <TableActionsContainer>
                  <div className="mt-2">
                    <Text type={'sub-heading'}>Contact sales</Text>
                    <div className="my-3">
                      <Text type={'heading'}>Alosia Rose</Text>
                      <div className="flex mt-1">
                        <Text type={'sub-heading'}>Mobile:&nbsp;</Text>
                        <Text type={'heading'}>&nbsp;+91 9847536687</Text>
                      </div>
                    </div>
                    <div className="my-3">
                      <Text type={'heading'}>Rohit Singh Solanki</Text>
                      <div className="flex mt-1">
                        <Text type={'sub-heading'}>Mobile:&nbsp;</Text>
                        <Text type={'heading'}>&nbsp;+91 8878183433 </Text>
                      </div>
                    </div>
                    <div className="flex">
                      <Text type={'sub-heading'}>Email:&nbsp;</Text>
                      <Text type={'heading'}>&nbsp;sales@skalebot.com</Text>
                    </div>
                  </div>
                </TableActionsContainer>
              </div>}
            </div>
            <div className="w-12 lg:w-4">
              <div className="flex flex-column justify-content-center align-items-center">
                <Text type={'heading'}>Scan and Explore Skalebot</Text>
                <div className="mt-3">
                  <TableActionsContainer>
                    <div className="w-full p-4">
                      {/* {userSub.isUserSub && (
                          <>
                            <QRCode
                              id="generatedQrCode"
                              size={156}
                              style={{
                                // height: "100%",
                                display: "block",
                                margin: "auto",
                              }}
                              value={`https://wa.me/${company?.phone}?text=Hi`}
                            />
                          </>
                        )} */}
                      {userSub.isUserSub ? (
                        <div className="flex  flex-align-center justify-content-center">
                          <div ref={ref} />
                        </div>
                      ) : (
                        <div className="w-12rem flex justify-content-center align-items-center border-dashed border-round-sm p-3 h-12rem">
                          <div className="w-12">
                            <Text type={'sub-heading'}>
                              Please contact sales to generate business QR code{' '}
                            </Text>
                          </div>
                        </div>
                      )}

                      {userSub.isUserSub && !isWhiteLabel && (
                        <div className="mt-6 text-center">
                          <Text type={'sub-heading'}>Powered by Skalebot</Text>
                        </div>
                      )}
                    </div>
                  </TableActionsContainer>

                  {userSub?.userSubType === 'none' ? (
                    ''
                  ) : (
                    <div className="mt-3 flex justify-content-center">
                      <CustomButton
                        varient="filled"
                        type={'button'}
                        onClick={onDownloadClick}
                        label={'Download QR'}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-6 flex flex-column justify-content-center align-items-center">
                <PaymentQR />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`flex flex-wrap w-11 m-auto pb-8`}>
        <div className="ml-2 w-6 min-w-min flex justify-content-center flex-grow-1 panel-right"></div>
      </div>
    </div>
  );
}

export default Profile;
